"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUrl = exports.getCompStyles = void 0;
var lodash_1 = __importDefault(require("lodash"));
var getValueFromTheme = function (val, colors) {
    var colorNumber = val && val.split('_')[1];
    return lodash_1.default.get(colors, colorNumber, val);
};
var capitalize = function (str) { return str.charAt(0).toUpperCase() + str.slice(1); };
exports.getCompStyles = function (compStyleKeys, styleProperties, colors) {
    return lodash_1.default.reduce(compStyleKeys, function (result, value, key) {
        var _a, _b;
        lodash_1.default.assign(result, (_a = {},
            _a[key] = getValueFromTheme(styleProperties[value], colors),
            _a));
        lodash_1.default.assign(result, (_b = {},
            _b["alpha" + capitalize(key)] = getValueFromTheme(styleProperties["alpha-" + value], colors),
            _b));
        return result;
    }, {});
};
exports.getUrl = function (baseUrl, compId, deviceType, locale) {
    var viewMode = 'site';
    if (baseUrl.indexOf('https') > -1) {
        return baseUrl + "?" + new URLSearchParams({
            compId: compId,
            deviceType: deviceType,
            locale: locale,
            viewMode: viewMode,
        });
    }
    else {
        return baseUrl.replace('http', 'https') + "?" + new URLSearchParams({
            compId: compId,
            deviceType: deviceType,
            locale: locale,
            viewMode: viewMode,
        });
    }
};
var SlideShowGalleryProperties_schema_1 = require("./SlideShowGalleryProperties.schema");
Object.defineProperty(exports, "SlideShowGalleryPropertiesSchema", { enumerable: true, get: function () { return SlideShowGalleryProperties_schema_1.SlideShowGalleryPropertiesSchema; } });
//# sourceMappingURL=index.js.map